import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../header/Header";
import Sidebarr from "../../sidebar/Sidebar";
import Tool from "../../sidebar/Tool";
import Footer from "../../footer/Footer";
import { VendorAction, updateVendorStatus, vendorDelete } from "../../action";
import { useDispatch, useSelector } from "react-redux";

export default function ProductList() {
  const vendor = useSelector((state) => state?.vendor);

  const dispatch = useDispatch();
  const vendorGetData = () => {
    dispatch(VendorAction());
  };
  useEffect(() => {
    vendorGetData();
  }, []);

  const blockStatus = (id) => {
    const status = "block";
    const data = { id, status };
    dispatch(updateVendorStatus(data));
    vendorGetData();
  };
  const unBlockStatus = (id) => {
    const status = "active";
    const data = { id, status };
    dispatch(updateVendorStatus(data));
    vendorGetData();
  };

  const deleteVendorBtn = (id) => {
    const data = { id };
    dispatch(vendorDelete(data));
  };

  const check = () => {
    vendorGetData();
  };

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        <Sidebarr />

        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <section className="content-header">
            <h1>Manage All Brands</h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li>
                <a href="#">Product Manage</a>
              </li>
              <li className="active">All Product</li>
            </ol>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-body">
                <Link to={"/addbrand"} className="add-new-brandBtnLink">
                  <button
                    type="button"
                    class="btn btn-success add-new-brandBtn"
                  >
                    <i class="fa fa-plus me-2"></i> &nbsp; Add New Brand
                  </button>
                </Link>

                <table className="table table-bordered table-striped" id=" ">
                  <thead>
                    <tr>
                      <th className="fw-bold"> #</th>
                      <th>Brand Name</th>
                      <th>Brand Email</th>
                      <th>Store Code</th>
                      <th>Image</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendor?.vendor?.map((vd, index) => {
                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>
                            <span className="text-uppercase fs-1">
                              {vd.brand}
                            </span>
                          </td>
                          <td>
                            <span className="text-uppercase fs-1">
                              {vd.email}
                            </span>
                          </td>
                          <td>
                            <span className="text-uppercase fs-1">
                              {vd.storeCode}
                            </span>
                          </td>
                          <td>
                            <img
                              src={vd.brandImage}
                              height={"80"}
                              width={"80"}
                            />{" "}
                          </td>
                          <td>
                            {/* <button className="btn btn-default" onClick={(e) => deleteVendorBtn(vd._id)}>
                            <i className="fa fa-trash"></i>
                          </button>
                          {" "}
                          <Link to={`/editVendor/${vd._id}`} className="btn btn-default">
                            <i className="fa fa-edit"></i>
                          </Link> */}
                            <button
                              className="btn btn-default"
                              onClick={(e) => alert("Coming Soon")}
                            >
                              <i className="fa fa-trash"></i>
                            </button>{" "}
                            <Link
                              to={`/editVendor/${vd._id}`}
                              className="btn btn-default"
                            >
                              <i className="fa fa-edit"></i>
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  );
}
